
var s = 0;



var scriptsList = ["//threadlogic.com/cdn/shop/t/225/assets/blueimp-jquery.ui.widget.js?v=11567595771158120061790793337", "//threadlogic.com/cdn/shop/t/225/assets/blueimp-jquery.iframe-transport.js?v=55610820773467321611790793336", "//threadlogic.com/cdn/shop/t/225/assets/blueimp-jquery.fileupload.js?v=165378899015369157421790793336", "//threadlogic.com/cdn/shop/t/225/assets/cloudinary-jquery-file-upload.js?v=182172400259282896161790793344", "//threadlogic.com/cdn/shop/t/225/assets/logo-upload.js?v=2&v=47808915140665351481791221649"]

function pf_append_js(scriptLocation, position = null){

  if(!position){
    var insertPosition = head;
  }
  else{  
    var insertPosition = document.getElementsByTagName("footer")[0];      
  }

  var theScript = document.createElement('script');
  theScript.setAttribute('src', scriptLocation); 
  insertPosition.appendChild(theScript);  

  return theScript;
}

function process_script(script){
  var scr = pf_append_js(script, 'footer')
  scr.onload = function(){    
    s++;
    if(scriptsList[s]){
      process_script(scriptsList[s])
    }
  }
}

function init_logo_script(){
    setTimeout(function(){
    	console.log('init logo scripts')      
      	process_script(scriptsList[0])
    }, 1000)
}
